import { useEffect, useState } from 'react';
import { Accordion, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiOutlineUp } from "react-icons/ai";
import { useLocation } from 'react-router-dom';
import { useMiddletier } from "../../common/middletier";
import Loading from '../../components/Loading';
import PageTitle from '../pageTitle/template_01';
import './template_02.css';

const Help = (props) => {
  const { desktopTitleToggle, mobileTitleToggle, dropdownTitle, backgroundImgTitle, desktopToggle, mobileToggle } = props;
  const [selectedKey, setSelectedKey] = useState('#about-us')
  const location = useLocation()
  const [isVisible, setIsVisible] = useState(false);
  const { i18n } = useTranslation();
  const { queries } = useMiddletier();
  const [helpContent, setHelpContent] = useState([]);
  const [isLoading, setLoading] = useState(false);



  useEffect(() => {
    setLoading(true)

    queries([{
      index: 'getFaq',
      method: 'getFaq',
      params: [
        { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
        { code: 'category', graphqlType: 'String', required: false, value: 'HELP' }
      ],
      attributes: []
    }])
      .then(({ data }) => {
        setLoading(false)
        setHelpContent(data['getFaq'])


      }).catch((error) => {
        setLoading(false)
        console.log('error: ', error)
      })

  }, [queries, i18n.resolvedLanguage]);


  const onSelect = (eventKey) => {
    setSelectedKey(eventKey)
  }

  useEffect(() => {
    const getLocation = location.hash ? location.hash?.substring(1) : (helpContent?.length > 0 && (`${helpContent[0].faq}`))
    let findHelp = helpContent.find((help) => help.faq === getLocation)
    setSelectedKey(findHelp)
    // const element = document.getElementById(location.hash.substring(1));
    // if (element) {
    //   const yOffset = element.offsetParent.offsetTop;
    //   window.scrollTo({ top: yOffset, behavior: 'smooth' });
    // }

  }, [location, helpContent])


  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  if ((desktopToggle || mobileToggle) === true) {
    return (
      <>
        <section id="help_02" className={`section ${desktopToggle ? "" : "d-lg-none"} ${mobileToggle ? "" : "d-none d-lg-block"}`} >
          <div className='help_body'>
            <PageTitle desktopToggle={desktopTitleToggle} mobileToggle={mobileTitleToggle} title={'help'} id={'help_title'} dropdown={dropdownTitle ?? false} backgroundImg={backgroundImgTitle ?? false} />
            <Container>
              <div dangerouslySetInnerHTML={{ __html: selectedKey?.content }} className='help_content'></div>
            </Container>
          </div>
        </section>
        {isVisible && (
          <button onClick={scrollToTop} className="scrollToTopButton" >
            <AiOutlineUp />
          </button>
        )}
        {isLoading && (<Loading />)}

      </>
    );
  }
}
export default Help;